/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import TextInput from '../common/TextInput';
import TextAreaInput from '../common/TextAreaInput';
import SelectInput from '../common/SelectInput';
import HelpRequestTopicSelectBox from './HelpRequestTopicSelectBox';
import Button from '../common/Button';
import {ITAAlert} from '../common/ITAAlert';
import * as googleCaptcha from '../../constants/googleCaptcha';
const Recaptcha = require('react-gcaptcha');

const HelpRequestForm =
  ({
    contactData,
    form,
    onSubmit,
    onChange,
    onCancel,
    onBlur,
    reCaptchaCallback,
    errors,
    submitStatus,
    emailSent
  })=> {
    let questions = [];
    if (form.formQuestions) {
      form.formQuestions.forEach(question => {
        let questionParts = [];
        question.questionParts.map(questionPart => {
          let type = questionPart.questionPartType;
          if (type === '4') {
          //text box
            let className = "", divClassName="";
            if (questionPart.questionPartName=="emailConfirmation"
              && contactData.emailConfirmation
              && contactData.emailConfirmation!==""){
              className="email-confirmation-verified";
              divClassName="email-confirmation-verified-div";
            }
            questionParts.push(
              <div className={"question-part col-xs-12 col-sm-8 " + divClassName}
                    key={questionPart.questionPartName}>
                <TextInput
                  type="text"
                  onChange={onChange}
                  placeHolder={questionPart.questionPartLabel}
                  value={contactData[questionPart.questionPartName]}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  className={"help-request-text-input " + className}
                  fieldClass={questionPart.questionPartName}
                  error={errors[questionPart.questionPartName]}
                  tooltip={questionPart.questionPartTooltipHelp}
                  onBlur={onBlur}
                  />
                <div dangerouslySetInnerHTML={{__html:questionPart.questionPartContextHelp}}/>
              </div>
            );
          } else if (type === '5') {
            //text area
            questionParts.push(
              <div className="question-part col-xs-12"
                    key={questionPart.questionPartName}>
                <TextAreaInput
                  onChange={onChange}
                  placeHolder={questionPart.questionPartLabel}
                  value={contactData[questionPart.questionPartName]?contactData[questionPart.questionPartName]:''}
                  label={questionPart.questionPartLabel}
                  name={questionPart.questionPartName}
                  className="help-request-text-input"
                  fieldClass={questionPart.questionPartName}
                  error={errors[questionPart.questionPartName]}
                  tooltip={questionPart.questionPartTooltipHelp}
                  onBlur={onBlur}
                  />
                <div dangerouslySetInnerHTML={{__html:questionPart.questionPartContextHelp}}/>
              </div>
            );
          } else if (type === '6' && questionPart.questionPartName == 'state') {
            //select box
            questionParts.push(
              <div className="question-part col-xs-12 col-sm-6"
                    key={questionPart.questionPartName}>
                <SelectInput
                  name={questionPart.questionPartName}
                  label="Your Location"
                  onChange={onChange}
                  value={contactData[questionPart.questionPartName]}
                  error={errors[questionPart.questionPartName]}
                  options={questionPart.questionPartOptions}
                  className={"help-request-select-input "
                    + questionPart.questionPartName}
                  fieldClass={questionPart.questionPartName}
                  defaultOption="--Select--"
                  onBlur={onBlur}/>
              </div>
            );
          } else if (type =='6') {
            questionParts.push(
              <div className="question-part col-xs-12 col-sm-6"
                   key={questionPart.questionPartName}>
                <HelpRequestTopicSelectBox
                  name={questionPart.questionPartName}
                  label={questionPart.questionPartLabel}
                  onChange={onChange}
                  value={contactData[questionPart.questionPartName]?contactData[questionPart.questionPartName]:'--Select--'}
                  error={errors[questionPart.questionPartName]}
                  options={questionPart.questionPartOptions}
                  className={"help-request-select-input "
                    + questionPart.questionPartName}
                  fieldClass={questionPart.questionPartName}
                  defaultOption="--Select--"
                  onBlur={onBlur}/>
              </div>
            );
          }
        });
        questions.push(
          <div className="question row"
                key={question.questionID || question.questionName}>
            {question.questionGroupHelpText &&
              <div dangerouslySetInnerHTML={{__html:question.questionGroupHelpText}}/>}
            {questionParts}
          </div>
        );
      });
    }
    return (
      <div className="help-request-page">
        <div id="help-request-form-panel">
          <div>
            <div className="form-instructions"
              dangerouslySetInnerHTML={{__html:form.formPageHelp}}/>
          </div>
          {emailSent &&
            <div className="row">
              <div className="col-xs-12 col-sm-9">
                <ITAAlert style="success"
                  message={
                  <div>
                    <div className="first-line">
                      Your request was successfully sent.
                    </div>
                  </div>
                }/>
              </div>
            </div>
          }
          <div className="required-info">
            <strong> All Fields are Required </strong>
          </div>
          <div className="mobile-border-container">
            <div className="col-xs-12 col-sm-9 row">
              {questions}
              <Recaptcha
                sitekey={googleCaptcha.key}
                verifyCallback={reCaptchaCallback}
              />
              <div id="submit-help-request-container" className="pull-right">
                <Button
                  className="submit-help-request pull-right"
                  value={"Submit"}
                  disabled={!submitStatus}
                  onClick={onSubmit}/>
                <a
                  className="btn btn-cancel cancel-help-request pull-right"
                  disabled={false}
                  href="#"
                  onClick={onCancel}>
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };


HelpRequestForm.propTypes = {
  contactData: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  reCaptchaCallback: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitStatus: PropTypes.bool.isRequired,
  emailSent: PropTypes.bool.isRequired
};

export default HelpRequestForm;



/** WEBPACK FOOTER **
 ** ./src/components/helpRequest/HelpRequestForm.js
 **/